import styled from 'styled-components';

export const DrawerContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  z-index: 9999;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const DrawerBox = styled.div`
  min-width: 400px;
  width: auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  //position: relative;
  padding: 16px;
  gap: 8px;
  background-color: #fff;
  box-shadow:
    0 17px 17px -7px rgba(0, 0, 0, 0.039),
    0 36px 28px -7px rgba(0, 0, 0, 0.102),
    0 1px 3px 0 rgba(0, 0, 0, 0.51);
  position: ${({ withContainer }) => (!withContainer ? 'fixed' : 'relative')};
  right: ${({ withContainer }) => (!withContainer ? '0' : 'initial')};
  top: ${({ withContainer }) => (!withContainer ? '0' : 'initial')};
  bottom: ${({ withContainer }) => (!withContainer ? '0' : 'initial')};
  z-index: 99999;
`;

export const DrawerHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: auto;

  .title {
    color: #25262b;
    font-size: 16px;
    font-weight: 400;
  }
`;

export const DrawerBody = styled.div`
  width: 100%;
  /* flex: 1; */
  overflow-y: auto;
  max-height: calc(100vh - 46px);
  scrollbar-gutter: stable;
`;

export const DrawerFooter = styled.div`
  width: 100%;
  //   height: 40px;
  display: flex;
  justify-content: flex-end;

  button {
    font-size: 14px;
    display: flex;
    align-items: center;
  }
`;
